import { devtools, persist } from 'zustand/middleware'
import create from 'zustand'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'
import { immer } from 'zustand/middleware/immer'

type IPackagesState = {
  packages: Record<string, PackageModel>
}

const state = (): IPackagesState => ({
  packages: {},
})

export const usePackageStoreNew = create<IPackagesState>()(
  persist(
    immer(
      devtools(state, {
        name: 'packageStoreMap',
      })
    ),
    {
      // middlewares
      name: 'packages_map',
      getStorage: () => localStorage,
      serialize: state => {
        if (state.state.packages) {
          const serialized = {}
          for (let packagesKey in state.state.packages) {
            // @ts-ignore
            serialized[packagesKey] = state.state.packages[packagesKey].serializeToPlainObject()
          }
          state.state.packages = serialized
        }

        return JSON.stringify(state)
      },
      deserialize: str => {
        const state = JSON.parse(str)

        if (state.state.packages) {
          for (let key in state.state.packages) {
            state.state.packages[key] = PackageModel.fromPlainObject(state.state.packages[key])
          }
        }

        return state
      },
    }
  )
)
